import requests from "./httpServices";

export const listEventLandingPages = (page = 1, limit = 20) =>
  requests.get(`/event-landing-pages?page=${page}&limit=${limit}`);

export const getEventLandingPage = (id) =>
  requests.get(`/event-landing-pages/${id}`);

export const createEventLandingPage = (data) =>
  requests.post(`/event-landing-pages`, data);

export const updateEventLandingPage = (id, data) =>
  requests.put(`/event-landing-pages/${id}`, data);

export const deleteEventLandingPage = (id) =>
  requests.delete(`/event-landing-pages/${id}`);

export const duplicateEventLandingPage = (id) =>
  requests.post(`/event-landing-pages/${id}/duplicate`, {});

// Public — fetch landing page by slug, no auth required
export const getPublicEventLandingPage = (slug) =>
  requests.get(`/event-landing-pages/public/${slug}`);

// Public — submit registration for a landing page
export const submitEventRegistration = (slug, formData) =>
  requests.post(`/event-landing-pages/public/${slug}/register`, formData);

// Auth — list registrations (owner only)
export const listEventRegistrations = (id) =>
  requests.get(`/event-landing-pages/${id}/registrations`);
